/**
 * Mirrors the buy box's rating row into the sticky bar.
 *
 * The sticky bar used to carry its own score and label as section settings,
 * which meant the same rating was typed out in two places and had to be kept in
 * step by hand. It had already fallen out of step twice: once when reviews were
 * added, once when a review section was switched off. Cloning the rendered row
 * leaves one place to edit.
 */
(() => {
  const SOURCE = '[class*="product-details"] .ms-rating-row, .product-information .ms-rating-row';
  const MOUNT = '[data-sticky-rating-mount]';

  const mirror = () => {
    const mount = document.querySelector(MOUNT);
    const source = document.querySelector(SOURCE);
    if (!mount || !source) return false;

    const clone = source.cloneNode(true);

    // Every star filled. At 13px a partially lit row reads as a rendering
    // fault; the score text beside it carries the actual precision.
    clone.querySelectorAll('.ms-rating-row__star--empty').forEach((star) => {
      star.classList.remove('ms-rating-row__star--empty');
    });
    // The clone is decorative here; the buy box already announces the rating.
    clone.setAttribute('aria-hidden', 'true');
    const score = source.getAttribute('data-score');
    const count = clone.querySelector('.ms-rating-row__count');
    if (score && count) count.textContent = `${score}/5.0`;

    clone.querySelectorAll('a').forEach((link) => {
      const span = document.createElement('span');
      span.className = link.className;
      span.textContent = link.textContent;
      link.replaceWith(span);
    });

    mount.replaceChildren(clone);
    mount.hidden = false;
    return true;
  };

  const start = () => {
    if (mirror()) return;
    // The buy box can render after this script runs; watch until it appears.
    const observer = new MutationObserver(() => {
      if (mirror()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
